import { Component, OnInit, Renderer2 } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PriceUtils } from 'src/app/base/utils/price-utils';
import { SpinnerService } from 'src/app/base/spinner/spinner.service';
import { PayTillNowParkingSessionInfoDTO } from 'src/app/base/models/models.swagger.generated';
import { PayTillNowSessionService } from './pay-till-now-session.service';
import { PayTillNowSessionClosedComponent } from './pay-till-now-session-closed/pay-till-now-session-closed.component';
import { PayTillNowSessionActiveComponent } from './pay-till-now-session-active/pay-till-now-session-active.component';
import { TranslateModule } from '@ngx-translate/core';
import { MobileHeaderComponent } from '../mobile-landing/shared/mobile-header/mobile-header.component';

@Component({
  selector: 'app-pay-till-now-session',
  imports: [PayTillNowSessionClosedComponent, PayTillNowSessionActiveComponent, TranslateModule, MobileHeaderComponent],
  templateUrl: './pay-till-now-session.component.html',
  styleUrl: './pay-till-now-session.component.scss',
})
export class PayTillNowSessionComponent implements OnInit {
  public showError: boolean = false;
  public errorMessage: string = '';
  public showSuccess: boolean = false;
  public sessionInfo: PayTillNowParkingSessionInfoDTO | null = null;

  public get sessionPriceWithCurrency(): string {
    if (this.sessionInfo) {
      return PriceUtils.getPriceWithCurrency(this.sessionInfo.totalWithVat, this.sessionInfo.currency);
    }
    return '';
  }

  public get title(): string | null {
    if (this.sessionInfo) {
      if (this.sessionInfo.isClosed) {
        return null;
      } else {
        return 'i18n.domain.pay-till-now-session.active-session-title'
      }
    }
    return '';
  }

  private sessionIdent: string | null = null;

  constructor(private renderer: Renderer2,
    private route: ActivatedRoute,
    private payTillNowSessionService: PayTillNowSessionService,
    private spinnerService: SpinnerService) { }

  ngOnInit() {
    this.renderer.addClass(document.body, 'body-login');

    this.route.paramMap.subscribe(params => {
      const sessionIdent = params.get('ident');
      if (sessionIdent && this.sessionIdent !== sessionIdent) {
        this.sessionIdent = sessionIdent;
        this.loadPayTillNowParkingSessionInfo();
      }
    });
  }

  public onDownloadReceipt(): void {
    // implemnent download receipt flow once we decide that on session close page we want a download receipt action
  }

  public onPayNow() {
    // implement pay now flow once we decide that on session active page we want a pay now after a while
  }

  private loadPayTillNowParkingSessionInfo() {
    if (!this.sessionIdent) {
      return;
    }

    this.spinnerService.show();
    this.payTillNowSessionService.loadPayTillNowParkingSessionInfo(this.sessionIdent).subscribe({next: sessionInfo => {
      this.sessionInfo = sessionInfo;
      this.showSuccess = true;
      this.spinnerService.reset();
    },
    error: err => {
      this.errorMessage = 'i18n.domain.pay-till-now-session.errors.session-not-found';
      this.showError = true;
      this.spinnerService.reset();
    }});
  }
}
